import {getCssUrl } from '../../../config/runtime'

export enum WebAwesomeComponent {
  Button = 'wa-button',
  ButtonGroup = 'wa-button-group',
  Details = 'wa-details',
  Dialog = 'wa-dialog',
  Dropdown = 'wa-dropdown',
  DropdownItem = 'wa-dropdown-item',
  Icon = 'wa-icon',
  Input = 'wa-input',
  Spinner = 'wa-spinner',
  Tooltip = 'wa-tooltip',
  Tree = 'wa-tree',
  TreeItem = 'wa-tree-item',
  Callout = 'wa-callout',
}

function tryLoadDependency(doc: Document, component: WebAwesomeComponent): void {
  if (doc?.getElementsByTagName(component)?.length === 0) {
    const newElement = document.createElement(component)
    newElement.setAttribute('style', 'display: none')
    newElement.textContent = 'AA autoloaded'
    doc.body.appendChild(newElement)
  }
}

export function tryLoadDependencies(doc: Document, components: WebAwesomeComponent[]): void {
  components.forEach((component) => {
    tryLoadDependency(doc, component)
  })
}

// Load light DOM styles for all components
// ! Remove tryLoadLightDOMStyles method from your web component constructor if Light DOM is not needed
export function tryLoadLightDOMStyles(cssFileName: string): void {
  const lightDOMCssUrl = getComponentCssUrl(`${cssFileName}`);
  const linkId = `lightdom-${cssFileName.replace('.css', '').toLowerCase()}`;

  // Check if already loaded to avoid duplicates
  if (!document.getElementById(linkId)) {
    const link = document.createElement('link')
    link.id = linkId
    link.rel = 'stylesheet'
    link.href = lightDOMCssUrl
    document.head.appendChild(link)
  }
}

/**
 * Utility functions for WebComponent runtime configuration
 * Provides centralized access to CDN URLs for global and component-specific assets
 */

/**
 * Get the CDN URL for global CSS files
 * @param filename - Optional specific global CSS file name (defaults to 'trustage-aa.css')
 * @returns Full CDN URL for the global CSS file
 */
export function getGlobalCssUrl(filename: string = 'trustage-aa.css'): string {
  return getCssUrl(filename)
}

/**
 * Get the CDN URL for component-specific CSS files
 * @param filename - The component CSS filename (e.g., 'Property.css')
 * @returns Full CDN URL for the component CSS file
 */
export function getComponentCssUrl(filename: string): string {
  return getCssUrl(`components/${filename}`)
}
